import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Heart, MapPin, Phone, User, Trash2, Plus } from "lucide-react";
import axios from "axios";
import { getBackendUrl } from "../utils/api";

const API_URL = getBackendUrl();

const FleetyGoFavoritesPage = () => {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const userData = localStorage.getItem("fleety_user");
    if (!userData) {
      navigate("/login");
      return;
    }
    const parsedUser = JSON.parse(userData);
    setUser(parsedUser);
    fetchFavorites(parsedUser.id);
  }, [navigate]);

  const fetchFavorites = async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/api/fleetygo/favorite-addresses/${userId}`);
      setFavorites(response.data);
    } catch (error) {
      console.error("Error fetching favorites:", error);
    }
    setLoading(false);
  };

  const deleteFavorite = async (id) => {
    try {
      await axios.delete(`${API_URL}/api/fleetygo/favorite-addresses/${id}`);
      setFavorites(favorites.filter(f => f.id !== id));
    } catch (error) {
      console.error("Error deleting favorite:", error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col" data-testid="fleetygo-favorites">
      <header className="bg-[#3FA9F5] p-4 flex items-center gap-4 sticky top-0 z-10">
        <button onClick={() => navigate("/fleetygo")} className="text-white">
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-white text-lg font-semibold">Favorite Addresses</h1>
      </header>

      <main className="flex-1 p-4">
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin w-8 h-8 border-4 border-[#3FA9F5] border-t-transparent rounded-full" />
          </div>
        ) : favorites.length === 0 ? (
          <div className="text-center py-12">
            <Heart size={48} className="text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500">No favorite addresses saved</p>
            <p className="text-sm text-gray-400 mt-1">Save addresses while booking for quick access</p>
          </div>
        ) : (
          <div className="space-y-3">
            {favorites.map((fav) => (
              <div key={fav.id} className="bg-white rounded-xl p-4 shadow-sm">
                <div className="flex items-start justify-between mb-2">
                  <span className="text-xs font-medium px-2 py-1 bg-[#3FA9F5]/10 text-[#3FA9F5] rounded-full">
                    {fav.label}
                  </span>
                  <button
                    onClick={() => deleteFavorite(fav.id)}
                    className="p-1 text-red-400 hover:text-red-500"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
                
                <div className="flex items-center gap-2 text-sm text-gray-900 mb-1">
                  <User size={14} className="text-gray-400" />
                  <span>{fav.name}</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-1">
                  <Phone size={14} className="text-gray-400" />
                  <span>{fav.phone}</span>
                </div>
                <div className="flex items-start gap-2 text-sm text-gray-500">
                  <MapPin size={14} className="text-gray-400 mt-0.5" />
                  <span>{fav.address}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default FleetyGoFavoritesPage;
